import { render } from "./nest_added_services.vue?vue&type=template&id=2acdd14c"
import script from "./nest_added_services.vue?vue&type=script&lang=js"
export * from "./nest_added_services.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__